import { css } from 'lit';

export const typographyStyles = css`
  :root {
    --default-paragraph-size: .8rem;
    --default-link-hover-text-decoration: none;
    --default-link-color: var(--color-base);
    --default-link-color-hover: var(--color-primary);
    --default-link-font-weight: var(--font-weight-strong);
  }

  h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
    color: var(--color-base);
    font-family: var(--font-family-heading);
    font-weight: var(--font-weight-light);
    margin-bottom: 1.2rem;
    margin-top: 0;
  }

  h1.no-margin, h2.no-margin, h3.no-margin, h4.no-margin, h5.no-margin, h6.no-margin,
  .h1.no-margin, .h2.no-margin, .h3.no-margin, .h4.no-margin, .h5.no-margin, .h6.no-margin {
    margin: 0;
  }

  h1, .h1 {
    font-size: 2.1rem;
    line-height: 1.1;
  }

  h2, .h2 {
    font-size: 1.7rem;
    line-height: 1.1;
    margin-top: 3.2rem;
  }

  h3, .h3 {
    font-size: 1.5rem;
    line-height: 1.2;
    margin-top: 3.2rem;
  }

  h4, .h4 {
    font-size: 1.1rem;
    line-height: 1.3;
    margin-top: 2.8rem;
  }

  h5, .h5 {
    font-size: 1rem;
    line-height: 1.3;
    margin-top: 2.8rem;
  }

  h6, .h6 {
    font-size: 0.9rem;
    line-height: 1.3;
    margin-top: 2.8rem;
  }

  h2:first-of-type, h3:first-of-type, h4:first-of-type, h5:first-of-type, h6:first-of-type,
  .h2:first-of-type, .h3:first-of-type, .h4:first-of-type, .h5:first-of-type, .h6:first-of-type {
    margin-top: 0;
  }

  /* -- Paragraph -- */
  p {
  font-family: var(--font-family-alternative);
    margin-bottom: 1.2rem;
  }
  p:last-child {
    margin-bottom: 0;
  }

  p, li, a {
    font-size: var(--default-paragraph-size);
    line-height: 1.5;
  }

  ul, ol {
    margin: 0;
    padding: 0;
  }

  .rich-text-container img {
    height: auto;
    max-width: 100%;
  }

  .rich-text-container ::slotted(img) {
    height: auto;
    max-width: 100%;
  }

  /* -- Blockquote -- */
  blockquote, blockquote p {

    font-size: .9rem;
    font-weight: var(--font-weight-base);
    line-height: 1.3;
    margin: 0;
  }

  /* -- Link -- */
  a {
    color: var(--color-base);
    font-family: var(--font-family-alternative);
    font-weight: var(--font-weight-strong);
    line-height: 1.2;
    transition: color 0.1s linear;
    text-decoration: none;
  }

  a:hover { color: var(--color-orange); }

  @media only screen and (min-width: 992px) {
    :root {
      --default-paragraph-size: 1.05rem;
    }
    h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
      margin-bottom: 1.4rem;
    }

    h1, .h1 {
      font-size: 2.6rem;
      margin-bottom: 1.6rem;
    }

    h2, .h2 {
      font-size: 2.2rem;
      margin-bottom: 1.6rem;
    }

    h3, .h3 {
      font-size: 2rem;
    }

    h4, .h4 {
      font-size: 1.4rem;
    }

    h5, .h5 {
      font-size: 1.2rem;
    }

    h6, .h6 {
      font-size: 1.1rem;
    }

    /* -- Paragraph -- */
    p, li {
      font-size: var(--default-paragraph-size);
    }

    /* -- Blockquote -- */
    blockquote, blockquote p {
      font-size: 1.1rem;
    }

    /* -- Pre -- */
    pre {
      font-size: 0.9rem;
    }
  }
`;

export const containerStyles = css`
  .container { margin: 0 auto; position: relative; width: 100%; }

  /* --Default -- */
  .container { max-width: calc(var(--container-width) + var(--container-padding-default) + var(--container-padding-default)); padding: 0 var(--container-padding-default); }
  .container--small { max-width: calc(var(--container-width-small) +  var(--container-padding-default) +  var(--container-padding-default)); padding: 0 var(--container-padding-default); }
  .container--large { max-width: calc(var(--container-width-large) +  var(--container-padding-default) +  var(--container-padding-default)); padding: 0  var(--container-padding-default); }

  /* --Extra small -- */
  @media only screen and (min-width: 576px){
    .container { max-width: calc(var(--container-width) + var(--container-padding-extra-small) + var(--container-padding-extra-small)); padding: 0 var(--container-padding-extra-small); }
    .container--small { max-width: calc(var(--container-width-small) +  var(--container-padding-extra-small) +  var(--container-padding-extra-small)); padding: 0 var(--container-padding-extra-small); }
    .container--large { max-width: calc(var(--container-width-large) +  var(--container-padding-extra-small) +  var(--container-padding-extra-small)); padding: 0  var(--container-padding-extra-small); }
  }

  /* --Small -- */
  @media only screen and (min-width: 768px){
    .container { max-width: calc(var(--container-width) + var(--container-padding-small) + var(--container-padding-small)); padding: 0 var(--container-padding-small); }
    .container--small { max-width: calc(var(--container-width-small) +  var(--container-padding-small) +  var(--container-padding-small)); padding: 0 var(--container-padding-small); }
    .container--large { max-width: calc(var(--container-width-large) +  var(--container-padding-small) +  var(--container-padding-small)); padding: 0  var(--container-padding-small); }
  }

  /* -- Medium -- */
  @media only screen and (min-width: 992px){
    .container { max-width: calc(var(--container-width) + var(--container-padding-medium) + var(--container-padding-medium)); padding: 0 var(--container-padding-medium); }
  .container--small { max-width: calc(var(--container-width-small) +  var(--container-padding-medium) +  var(--container-padding-medium)); padding: 0 var(--container-padding-medium); }
  .container--large { max-width: calc(var(--container-width-large) +  var(--container-padding-medium) +  var(--container-padding-medium)); padding: 0  var(--container-padding-medium); }
  }

  /* --Large -- */
  @media only screen and (min-width: 1175px){
    .container { max-width: calc(var(--container-width) + var(--container-padding-large) + var(--container-padding-large)); padding: 0 var(--container-padding-large); }
  .container--small { max-width: calc(var(--container-width-small) +  var(--container-padding-large) +  var(--container-padding-large)); padding: 0 var(--container-padding-large); }
  .container--large { max-width: calc(var(--container-width-large) +  var(--container-padding-large) +  var(--container-padding-large)); padding: 0  var(--container-padding-large); }
  }

  /* --Extra large -- */
  @media only screen and (min-width: 1440px){
    .container { max-width: calc(var(--container-width) + var(--container-padding-extra-large) + var(--container-padding-extra-large)); padding: 0 var(--container-padding-extra-large); }
  .container--small { max-width: calc(var(--container-width-small) +  var(--container-padding-extra-large) +  var(--container-padding-extra-large)); padding: 0 var(--container-padding-extra-large); }
  .container--large { max-width: calc(var(--container-width-large) +  var(--container-padding-extra-large) +  var(--container-padding-extra-large)); padding: 0  var(--container-padding-extra-large); }
  }
`;

export const normalizeStyles = css`
  *,
  *::before,
  *::after
  { box-sizing: border-box; }
`;

export const moduleSpacingStyles = css`
  .module_top-padding-xxl { padding-top: calc(var(--module-spacing-default) * var(--module-spacing-scale-xxl)); }
  .module_top-padding-xl { padding-top: calc(var(--module-spacing-default) * var(--module-spacing-scale-xl)); }
  .module_top-padding-l { padding-top: calc(var(--module-spacing-default) * var(--module-spacing-scale-l)); }
  .module_top-padding-m { padding-top: var(--module-spacing-default); }
  .module_top-padding-s { padding-top: calc(var(--module-spacing-default) * var(--module-spacing-scale-s)); }
  .module_top-padding-xs { padding-top: calc(var(--module-spacing-default) * var(--module-spacing-scale-xs)); }
  .module_top-padding-xxs { padding-top: calc(var(--module-spacing-default) * var(--module-spacing-scale-xxs)); }
  .module_top-padding-0 { padding-top: 0; }

  .module_bottom-padding-xxl { padding-bottom: calc(var(--module-spacing-default) * var(--module-spacing-scale-xxl)); }
  .module_bottom-padding-xl { padding-bottom: calc(var(--module-spacing-default) * var(--module-spacing-scale-xl)); }
  .module_bottom-padding-l { padding-bottom: calc(var(--module-spacing-default) * var(--module-spacing-scale-l)); }
  .module_bottom-padding-m { padding-bottom: var(--module-spacing-default); }
  .module_bottom-padding-s { padding-bottom: calc(var(--module-spacing-default) * var(--module-spacing-scale-s)); }
  .module_bottom-padding-xs { padding-bottom: calc(var(--module-spacing-default) * var(--module-spacing-scale-xs)); }
  .module_bottom-padding-xxs { padding-bottom: calc(var(--module-spacing-default) * var(--module-spacing-scale-xxs)); }
  .module_bottom-padding-0 { padding-bottom: 0; }

  @media only screen and (min-width: 576px) {
    .module_top-padding-xxl { padding-top: calc(var(--module-spacing-extra-small) * var(--module-spacing-scale-xxl)); }
    .module_top-padding-xl { padding-top: calc(var(--module-spacing-extra-small) * var(--module-spacing-scale-xl)); }
    .module_top-padding-l { padding-top: calc(var(--module-spacing-extra-small) * var(--module-spacing-scale-l)); }
    .module_top-padding-m { padding-top: var(--module-spacing-extra-small); }
    .module_top-padding-s { padding-top: calc(var(--module-spacing-extra-small) * var(--module-spacing-scale-s)); }
    .module_top-padding-xs { padding-top: calc(var(--module-spacing-extra-small) * var(--module-spacing-scale-xs)); }
    .module_top-padding-xxs { padding-top: calc(var(--module-spacing-extra-small) * var(--module-spacing-scale-xxs)); }
    .module_top-padding-0 { padding-top: 0; }

    .module_bottom-padding-xxl { padding-bottom: calc(var(--module-spacing-extra-small) * var(--module-spacing-scale-xxl)); }
    .module_bottom-padding-xl { padding-bottom: calc(var(--module-spacing-extra-small) * var(--module-spacing-scale-xl)); }
    .module_bottom-padding-l { padding-bottom: calc(var(--module-spacing-extra-small) * var(--module-spacing-scale-l)); }
    .module_bottom-padding-m { padding-bottom: var(--module-spacing-extra-small); }
    .module_bottom-padding-s { padding-bottom: calc(var(--module-spacing-extra-small) * var(--module-spacing-scale-s)); }
    .module_bottom-padding-xs { padding-bottom: calc(var(--module-spacing-extra-small) * var(--module-spacing-scale-xs)); }
    .module_bottom-padding-xxs { padding-bottom: calc(var(--module-spacing-extra-small) * var(--module-spacing-scale-xxs)); }
    .module_bottom-padding-0 { padding-bottom: 0; }
  }

  @media only screen and (min-width: 768px) {
    .module_top-padding-xxl { padding-top: calc(var(--module-spacing-small) * var(--module-spacing-scale-xxl)); }
    .module_top-padding-xl { padding-top: calc(var(--module-spacing-small) * var(--module-spacing-scale-xl)); }
    .module_top-padding-l { padding-top: calc(var(--module-spacing-small) * var(--module-spacing-scale-l)); }
    .module_top-padding-m { padding-top: var(--module-spacing-small); }
    .module_top-padding-s { padding-top: calc(var(--module-spacing-small) * var(--module-spacing-scale-s)); }
    .module_top-padding-xs { padding-top: calc(var(--module-spacing-small) * var(--module-spacing-scale-xs)); }
    .module_top-padding-xxs { padding-top: calc(var(--module-spacing-small) * var(--module-spacing-scale-xxs)); }
    .module_top-padding-0 { padding-top: 0; }

    .module_bottom-padding-xxl { padding-bottom: calc(var(--module-spacing-small) * var(--module-spacing-scale-xxl)); }
    .module_bottom-padding-xl { padding-bottom: calc(var(--module-spacing-small) * var(--module-spacing-scale-xl)); }
    .module_bottom-padding-l { padding-bottom: calc(var(--module-spacing-small) * var(--module-spacing-scale-l)); }
    .module_bottom-padding-m { padding-bottom: var(--module-spacing-small); }
    .module_bottom-padding-s { padding-bottom: calc(var(--module-spacing-small) * var(--module-spacing-scale-s)); }
    .module_bottom-padding-xs { padding-bottom: calc(var(--module-spacing-small) * var(--module-spacing-scale-xs)); }
    .module_bottom-padding-xxs { padding-bottom: calc(var(--module-spacing-small) * var(--module-spacing-scale-xxs)); }
    .module_bottom-padding-0 { padding-bottom: 0; }
  }

  @media only screen and (min-width: 992px) {
    .module_top-padding-xxl { padding-top: calc(var(--module-spacing-medium) * var(--module-spacing-scale-xxl)); }
    .module_top-padding-xl { padding-top: calc(var(--module-spacing-medium) * var(--module-spacing-scale-xl)); }
    .module_top-padding-l { padding-top: calc(var(--module-spacing-medium) * var(--module-spacing-scale-l)); }
    .module_top-padding-m { padding-top: var(--module-spacing-medium); }
    .module_top-padding-s { padding-top: calc(var(--module-spacing-medium) * var(--module-spacing-scale-s)); }
    .module_top-padding-xs { padding-top: calc(var(--module-spacing-medium) * var(--module-spacing-scale-xs)); }
    .module_top-padding-xxs { padding-top: calc(var(--module-spacing-medium) * var(--module-spacing-scale-xxs)); }
    .module_top-padding-0 { padding-top: 0; }

    .module_bottom-padding-xxl { padding-bottom: calc(var(--module-spacing-medium) * var(--module-spacing-scale-xxl)); }
    .module_bottom-padding-xl { padding-bottom: calc(var(--module-spacing-medium) * var(--module-spacing-scale-xl)); }
    .module_bottom-padding-l { padding-bottom: calc(var(--module-spacing-medium) * var(--module-spacing-scale-l)); }
    .module_bottom-padding-m { padding-bottom: var(--module-spacing-medium); }
    .module_bottom-padding-s { padding-bottom: calc(var(--module-spacing-medium) * var(--module-spacing-scale-s)); }
    .module_bottom-padding-xs { padding-bottom: calc(var(--module-spacing-medium) * var(--module-spacing-scale-xs)); }
    .module_bottom-padding-xxs { padding-bottom: calc(var(--module-spacing-medium) * var(--module-spacing-scale-xxs)); }
    .module_bottom-padding-0 { padding-bottom: 0; }
  }

  @media only screen and (min-width: 1175px) {
    .module_top-padding-xxl { padding-top: calc(var(--module-spacing-large) * var(--module-spacing-scale-xxl)); }
    .module_top-padding-xl { padding-top: calc(var(--module-spacing-large) * var(--module-spacing-scale-xl)); }
    .module_top-padding-l { padding-top: calc(var(--module-spacing-large) * var(--module-spacing-scale-l)); }
    .module_top-padding-m { padding-top: var(--module-spacing-large); }
    .module_top-padding-s { padding-top: calc(var(--module-spacing-large) * var(--module-spacing-scale-s)); }
    .module_top-padding-xs { padding-top: calc(var(--module-spacing-large) * var(--module-spacing-scale-xs)); }
    .module_top-padding-xxs { padding-top: calc(var(--module-spacing-large) * var(--module-spacing-scale-xxs)); }
    .module_top-padding-0 { padding-top: 0; }

    .module_bottom-padding-xxl { padding-bottom: calc(var(--module-spacing-large) * var(--module-spacing-scale-xxl)); }
    .module_bottom-padding-xl { padding-bottom: calc(var(--module-spacing-large) * var(--module-spacing-scale-xl)); }
    .module_bottom-padding-l { padding-bottom: calc(var(--module-spacing-large) * var(--module-spacing-scale-l)); }
    .module_bottom-padding-m { padding-bottom: var(--module-spacing-large); }
    .module_bottom-padding-s { padding-bottom: calc(var(--module-spacing-large) * var(--module-spacing-scale-s)); }
    .module_bottom-padding-xs { padding-bottom: calc(var(--module-spacing-large) * var(--module-spacing-scale-xs)); }
    .module_bottom-padding-xxs { padding-bottom: calc(var(--module-spacing-large) * var(--module-spacing-scale-xxs)); }
    .module_bottom-padding-0 { padding-bottom: 0; }
  }

  @media only screen and (min-width: 1440px) {
    .module_top-padding-xxl { padding-top: calc(var(--module-spacing-extra-large) * var(--module-spacing-scale-xxl)); }
    .module_top-padding-xl { padding-top: calc(var(--module-spacing-extra-large) * var(--module-spacing-scale-xl)); }
    .module_top-padding-l { padding-top: calc(var(--module-spacing-extra-large) * var(--module-spacing-scale-l)); }
    .module_top-padding-m { padding-top: var(--module-spacing-extra-large); }
    .module_top-padding-s { padding-top: calc(var(--module-spacing-extra-large) * var(--module-spacing-scale-s)); }
    .module_top-padding-xs { padding-top: calc(var(--module-spacing-extra-large) * var(--module-spacing-scale-xs)); }
    .module_top-padding-xxs { padding-top: calc(var(--module-spacing-extra-large) * var(--module-spacing-scale-xxs)); }
    .module_top-padding-0 { padding-top: 0; }

    .module_bottom-padding-xxl { padding-bottom: calc(var(--module-spacing-extra-large) * var(--module-spacing-scale-xxl)); }
    .module_bottom-padding-xl { padding-bottom: calc(var(--module-spacing-extra-large) * var(--module-spacing-scale-xl)); }
    .module_bottom-padding-l { padding-bottom: calc(var(--module-spacing-extra-large) * var(--module-spacing-scale-l)); }
    .module_bottom-padding-m { padding-bottom: var(--module-spacing-extra-large); }
    .module_bottom-padding-s { padding-bottom: calc(var(--module-spacing-extra-large) * var(--module-spacing-scale-s)); }
    .module_bottom-padding-xs { padding-bottom: calc(var(--module-spacing-extra-large) * var(--module-spacing-scale-xs)); }
    .module_bottom-padding-xxs { padding-bottom: calc(var(--module-spacing-extra-large) * var(--module-spacing-scale-xxs)); }
    .module_bottom-padding-0 { padding-bottom: 0; }
  }
`;
